 <template>
  <ValidationProvider slim rules="required" v-slot="state">
    <div :class="validationState(state)" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio item="yes" :label="$t('common.yes')" data-cy="tile-yes" group="hasEan" v-model="hasEanSelection"></TileRadio>
        <TileRadio item="no" :label="$t('common.no')" data-cy="tile-no" group="hasEan" v-model="hasEanSelection"></TileRadio>
      </div>
      <error-message :error="state.errors[0]"></error-message>
    </div>
  </ValidationProvider>
  
</template>

<script lang="ts">
import Component from 'vue-class-component'
import { Emit, Prop } from 'vue-property-decorator'
import FieldBox from '../../Shared/FieldBox'

@Component({
  name: 'has-ean-selector'
})
export default class HasEanSelector extends FieldBox {
  //#region [Property]
  @Prop({ type: String, default: '' }) public readonly value!: string | null
  //#endregion

  //#region [Computed]
  public get hasEanSelection(): string | null {
    return this.value
  }
  public set hasEanSelection(value: string | null) {
    this.change(value)
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: string | null): string | null {
    return value
  }
  //#endregion
}
</script>
